export const DIALOG_VISIBLE = 'DIALOG_VISIBLE';
export const dialogVisible = (visible, url) => ({type: DIALOG_VISIBLE, visible, url});



// WEBPACK FOOTER //
// ./src/course_details/actions.js